import { carousels, carousels_mobile, carouselInit } from './carousel';

export default function () {
  document.addEventListener('shopify:section:load', (e) => {
    const section_id = e.detail.sectionId;
    // Is this a carousel?
    const heroCarousel = document.querySelector(`#HeroCarousel${section_id}`);
    if (heroCarousel) {
      let index = 0;
      let mobile_index = 0;

      // Has this carousel already been initialized? Destroy it if so...
      if (carousels[section_id]) {
        // Save the current slide's index so we can immediately reinitialize at the same slide later
        index = carousels[section_id].selectedIndex;
        mobile_index = carousels_mobile[section_id].selectedIndex;
        // Destroy the existing one since it exists
        carousels[section_id].destroy();
        carousels_mobile[section_id].destroy();
        delete carousels[section_id];
        delete carousels_mobile[section_id];
      }

      // Reinitialize the carousel with new options
      carouselInit(section_id, heroCarousel, index);
      carouselInit(section_id, document.querySelector(`#HeroCarousel--mobile${section_id}`), mobile_index);
    }
  });

  document.addEventListener('shopify:block:select', (e) => {
    const section_id = e.detail.sectionId;
    // Is this a carousel?
    const heroCarousel = document.querySelector(`#HeroCarousel${section_id}`);
    if (heroCarousel) {
      // Navigate to the correct slide and pause autoplay
      const block_id = e.detail.blockId;
      const heroSlide = document.querySelector(`#HeroSlide${block_id}`);
      const index = Array.from(heroCarousel.children).indexOf(heroSlide);
      carousels[section_id].select(index);
      carousels[section_id].pausePlayer();
      carousels_mobile[section_id].select(index);
      carousels_mobile[section_id].pausePlayer();
    }
  });

  document.addEventListener('shopify:block:deselect', (e) => {
    const section_id = e.detail.sectionId;
    // Is this a carousel?
    const heroCarousel = document.querySelector(`#HeroCarousel${section_id}`);
    if (heroCarousel) {
      // Unpause autoplay
      carousels[section_id].unpausePlayer();
      carousels_mobile[section_id].unpausePlayer();
    }
  });
}
